<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-7">
                              <div class="maheading_2">
                                <h5 class="modal-title">Subscription</h5>
                              </div>  
                            </div>
                            <div class="col-5 text-right">
                              <div class="col-12 p-0">
                                {{ usedLicense }}/{{ totalLicense }} Mentee Seats Used
                              </div>
                              <div class="col-12 p-0">
                                Subscription Expires: {{ accountExpire }}
                              </div>
                            </div>
                          </div>


                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" v-for="(list, index) in subscriptions" :key="index">
                            <div class="row">
                                <div class="col-8">
                                  <div class="custom-control custom-radio custom-control-inline" style="margin-right: 0px !important;">

                                  <input
                                    type="radio"
                                    v-bind:id="'is_primary_' + index"
                                    :ref="'is_primary_' + index"
                                    v-bind:name="'is_primary[' + index + ']'"
                                    v-model="list.isSelected"
                                    :checked="list.checked" class="custom-control-input" 
                                    @click="clickPrimary(index)"
                                    :value="1" style="margin-top: -2px !important; height: 10px;">
                                    <label 
                                      class="custom-control-label" 
                                      :for="'is_primary_' + index" style="margin-top: 8px !important;"></label>
                                  </div>

                                  {{ list.packageName }}
                                </div>
                                <div class="col-4 text-right seat_qty pr-4 bold" v-if="list.packagediscount > 0">
                                  ({{ list.packagediscount }}% Savings)
                                </div>
                            </div>
                            <div class="row " >
                              <div class="col-8 seat_qty" style="padding-left: 33px !important;">
                                <i>{{ list.packageQty }}</i>
                              </div>
                              <div class="col-4">
                                &nbsp;
                              </div>
                            </div>
                            <div class="row pb-1" >
                              <div class="col-8 pt-1">
                                &nbsp;
                              </div>
                              <div class="col-4 text-right pr-4">
                                &#36;{{ list.packagePrice }}/annually
                              </div>
                            </div>
                            <div class="clear"></div>
                          </div>

                          <div class="text-center m-4">
                              <button :disabled="process_payment_disable" type="button" class="btn btn-md ma-blue-btn" @click="openSubscriptionReviewModal">
                                  Review
                              </button>
                          </div>





                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <SubscriptionReview
          :isModalVisible="isSubscriptionReviewModalVisible"
          :packageId="packageId"
          ref="SubscriptionReviewModal"
          @close="isSubscriptionReviewModalVisible = false">
        </SubscriptionReview>


    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)


import SubscriptionReview from './subscriptionReview.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            currentpackageId: '',
            currentpackageQty: '',
            packageId: '',
            totalLicense: '',
            usedLicense: '',
            accountExpire: '',
            process_payment_disable: false,
            isSubscriptionReviewModalVisible: false,
            totalLicenseWithoutRenew: '',
        }
    },
    components: {
      SubscriptionReview,
    },
    methods: {       
        hide() { 
            this.$emit('close');

        },
        openSubscriptionReviewModal() {
          if(this.currentpackageId == this.packageId) {
            alert("You are already subscribed to this package. Please upgrade your package to proceed.");
            return false;
          }
          else {
              this.isSubscriptionReviewModalVisible = true;
              this.$refs.SubscriptionReviewModal.loadInitialData();
          }
        },
        clickPrimary: function(index) {
          if(this.currentpackageQty > this.subscriptions[index].qty) {
            alert("Please upgrade your package.");
            var val = 'is_primary_' + index;
            document.getElementById(val).checked = false;
            return false;
          }
          else if(this.totalLicenseWithoutRenew > this.subscriptions[index].qty) {
            alert("Please upgrade your package.");
            var val = 'is_primary_' + index;
            document.getElementById(val).checked = false;
            return false;
          }
          else {
            for(var i=0; i < this.subscriptions.length; i++) {
              this.subscriptions[i].isSelected = 0;
              this.subscriptions[i].checked = false;
            }
            this.subscriptions[index].isSelected = 1;
            this.subscriptions[index].checked = true;
            this.packageId = this.subscriptions[index].id;
          }
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'managelicense'});              
                window.open(routeData.href, '_self');                
            }
        },
        getSubscriptionLists() {

          axios('/desktop/get-account-seat-subscription-lists/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.subscriptions = resp.data.subscriptions;
            this.totalLicense = resp.data.totalLicense;
            this.usedLicense = resp.data.usedLicense;
            this.accountExpire = resp.data.accountExpire;
            this.packageId = resp.data.packageId;
            this.currentpackageId = resp.data.packageId;
            this.currentpackageQty = resp.data.currentpackageQty;
            this.totalLicenseWithoutRenew = resp.data.totalLicenseWithoutRenew;

          })
          .catch(() => {
          });      

        },
        loadInitialData() {
          this.getSubscriptionLists();
        },
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus {
  color: #FFF !important; 
  border-radius: 15px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  padding: 5px 20px;
}
.receipt-heading {
  float: left;
  font-weight: normal;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
  text-align: right;
}
.receipt-heading-3 {
  width: 18%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 30%;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.invoice_link { color: #00ACEE; }
</style>




// WEBPACK FOOTER //
// src/components/manager/subscriptionlists.vue